import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'
export const Wrapper = styled.div`
    position: relative;

    ${({ orientation }) =>
        orientation === 'landscape' &&
        css`
            width: 100%;
            display: flex;
            align-items: center;
        `}
`
export const CheckBoxWrapper = styled.div`
    position: relative;
    ${({ orientation }) =>
        orientation === 'portrait' &&
        css`
            transform: rotateZ(90deg);
            margin: 6px 29px 30px 21px;
        `}
`
export const CheckBoxLabel = styled.label`
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 36px;

    ${!isDesktop &&
        css`
            width: 85px;
            height: 50px;
        `}

    border-radius: 30px;
    ${({ orientation }) =>
        orientation === 'portrait'
            ? css`
                  background-color: #bebebe;
              `
            : css`
                  background-color: #4f4f4f;
              `}
    cursor: pointer;
    opacity: ${props => (props.reduceOpacity ? '0.5' : '1')};
    &::after {
        content: '';
        display: block;
        width: 30px;
        height: 30px;

        ${!isDesktop &&
            css`
                width: 45px;
                height: 45px;
                background-size: 25px 25px;
            `}

        border-radius: 50%;
        margin: 3px 2px;
        ${({ orientation }) =>
            orientation === 'portrait'
                ? css`
                      background-color: #ffffff;
                  `
                : css`
                      background-color: #333;
                  `}
        background-image: url('/img/tiles/student/gestures/hand.svg');
        background-repeat: no-repeat;
        background-position: center;
        ${({ orientation }) =>
            orientation === 'portrait' &&
            css`
                transform: rotateZ(-90deg);
            `}
        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
        transition: margin 0.2s;
    }
`
export const CheckBox = styled.input`
    opacity: 0;
    z-index: 1;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    ${!isDesktop &&
        css`
            height: 45px;
            width: 45px;
        `}
    ${({ orientation }) =>
        orientation === 'landscape' &&
        css`
            margin: 0;
        `}
    &:checked + ${CheckBoxLabel} {
        ${({ orientation }) =>
            orientation === 'portrait'
                ? css`
                      background-color: #e87d7c;
                  `
                : css`
                      background-color: #27ae60;
                  `}
        display: flex;
        justify-content: flex-end;
        align-items: center;
        opacity: ${props => (props.reduceOpacity ? '0.5' : '1')};
        &::after {
            content: '';
            display: block;
            height: 30px;
            ${!isDesktop &&
                css`
                    height: 45px;
                `}
            border-radius: 50%;
            margin-left: 27px;
            transition: margin 0.2s;
        }
    }
`
export const PieTimerWrapper = styled.div`
    position: absolute;
    width: 30px;
    height: 30px;
    ${!isDesktop &&
        css`
            width: 45px;
            height: 45px;
        `}
    z-index: 10;
    margin: 3px 2px;
    ${({ orientation }) =>
        orientation === 'portrait' &&
        css`
            transform: rotateZ(-90deg);
        `}
`
